import * as PIXI from 'pixi.js';
import Config from './Config';

export default class Energy extends PIXI.Container {
  constructor() {
    super();

    this.border = null;
    this.bar = null;

    this.lastEnergy = Config.PLAYER_ENERGY_MAX;

    this.maxBarWidth = 222;

    this.position.set(20, 20);
  }

  onResourcesLoaded() {
    this.border = new PIXI.Sprite(PIXI.Loader.shared.resources['energy-border'].texture);
    this.border.anchor.set(0, 0.5);
    this.border.position.set(0, 37);

    this.bar = new PIXI.TilingSprite(
      PIXI.Loader.shared.resources['energy-bar'].texture, this.maxBarWidth, 32
    );

    this.bar.anchor.set(0, 0.5);
    this.bar.position.set(68, 37);

    this.addChild(this.bar, this.border);
  }

  update(dt, [
    background,
    player,
    ground,
    ...treasures
  ], viewport) {}

  setValue(energy) {
    if (!this.bar) return;

    if (this.lastEnergy === energy) return;

    this.lastEnergy = energy;
    this.bar.width = this.maxBarWidth * energy / Config.PLAYER_ENERGY_MAX;
  }
}
